import { createAccountKit } from "@jkast90/kast-common/account";
import { session, signIn, signOut } from "../auth/session";
import { adminMode } from "./adminMode";
import { getDeploymentConfig } from "./deployment-config";
import { useMyPicture } from "../library/queries";
import { themeStore } from "./theme";

/** CloudBoy's id in the kast-dev bug report inbox: its deploy and metadata prefix. */
const BUG_REPORT_APP = "cloudboy";

// The account pieces bound to the session (kast-common's account kit). What
// stays CloudBoy's: the sign-in (offline and the desktop app, auth/session.ts),
// the offline chip and `canSignIn` (AuthMenu, TopBar; the player's AuthMenu
// draws its own markup from the kit's state), and the pages around each piece.
export const { AccountControls, AccountPage, ProfileToolbar, BugReportPage, AppSettings, useAdmin } = createAccountKit({
  session,
  signIn,
  signOut: () => signOut(),
  themeStore,
  admin: adminMode,
  usePicture: useMyPicture,
  apiUrl: () => getDeploymentConfig().apiUrl,
  paths: { profile: "/profile" },
  bugReport: {
    app: BUG_REPORT_APP,
    classNames: {
      page: "kui-page about-main",
      section: "panel",
      button: "btn",
      primaryButton: "btn primary",
      input: "input",
      label: "field-label",
      hint: "kui-muted kui-small",
    },
  },
  settings: {
    adminDescription: "The Admin page, and admin actions elsewhere, on this device",
    help: [{ id: "about", label: "About CloudBoy", href: "/about" }],
  },
});
